import React, { useEffect, useState } from "react";
import newsapi from "./newsAuth";
import db from "./firebase";

function TopStories(props) {
  const { title } = props;
  const [articles, setArticles] = useState(undefined);

  useEffect(() => {
    newsapi.v2
      .topHeadlines({
        country: "us",
        pageSize: "100",
        language: "en",
      })
      .then((response) => {
        let filteredResponse = response.articles.filter(
          (r) => !r.title.includes("GMT")
        );
        const uniqueResponses = Array.from(
          new Set(filteredResponse.map((r) => r.title))
        ).map((title) => {
          return filteredResponse.find((r) => r.title === title);
        });
        setArticles(uniqueResponses);
        let d = new Date();
        let month = parseInt((d.getMonth() + 1).toString());
        let day = d.getDate().toString();
        let year = d.getUTCFullYear();
        db.collection(title)
          .doc(month + day + year)
          .set({
            uniqueResponses,
          })
          .then(function (docRef) {
            console.log("Document written with ID: ", docRef);
          })
          .catch(function (error) {
            console.error("Error adding document: ", error);
          });
      });
  }, [title]);

  if (!articles) return <div>Loading...</div>;

  return (
    <div className="App">
      <h2>News Populated</h2>
    </div>
  );
}

export default TopStories;
